import { ShoppingCard } from '@package/core/src/shoppingCart/types';

export type FreeShippingsProps = {
  cartData: ShoppingCard;
};

export const freeShippingMessageTitle =
  '<h2 style="font-size: 24px; margin-top: 0;">Free Shipping Offer</h2><div style="colo: black; padding-bottom: 15px">Based on the products in your cart, here are the details to qualify for free shipping:</div>';
